import React, { useRef, useEffect } from "react";
import { Slide } from "react-slideshow-image";

const ScreenshotsSlideshow = ({ images, currentIndex, keyName }) => {
  const slideShow = useRef(null);
  const properties = {
    duration: 800,
    transitionDuration: 500,
    infinite: true,
    indicators: false,
    arrows: false,
    pauseOnHover: false,
    autoplay: false,
    defaultIndex: 0
  };

  useEffect(() => {
    if (slideShow && slideShow.current) {
      slideShow.current.goTo(currentIndex);
    }
  }, [currentIndex]);

  return (
    <div className="slide-container">
      <Slide {...properties} ref={slideShow}>
        {images.map(({ url, alternativeText, formats }, i) => {
          const imageUrl = formats?.medium?.url || url;
          return <img key={`slideImage-${keyName}-${i}`} alt={alternativeText} src={imageUrl} />;
        })}
      </Slide>
    </div>
  );
};

export default ScreenshotsSlideshow;
